import { useAuth } from "@/auth/AuthContext";
import { buildInfo } from "@/lib/buildInfo";

import { Box, List, ListItem, ListItemText, Divider, Typography, Button } from "@mui/material";
import SettingsOffline from "./SettingsOffline";
import SettingsLocation from "./SettingsLocation";

export default function SettingsPage() {
  const { user, logoutUser } = useAuth();

  return (
    <Box px={2} py={1}>
      {/* Account Section */}
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ pl: 1 }}
      >
        Account
      </Typography>

      <List sx={{ bgcolor: "background.paper", borderRadius: 2 }}>
        <ListItem>
          <ListItemText primary="Username" secondary={user?.username} />
        </ListItem>

        <Divider component="li" />

        <ListItem
          secondaryAction={
            <Button
              color="error"
              variant="text"
              size="small"
              onClick={logoutUser}
            >
              Logout
            </Button>
          }
        >
          <ListItemText primary="Email" secondary={user?.email} />
        </ListItem>
      </List>

      {/* Offline & Sync Section */}
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ pl: 1, mt: 3 }}
      >
        Offline & Sync
      </Typography>

      <List sx={{ bgcolor: "background.paper", borderRadius: 2 }}>
        <SettingsOffline />
      </List>

      {/* App Section */}
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ pl: 1, mt: 3 }}
      >
        App
      </Typography>

      <List sx={{ bgcolor: "background.paper", borderRadius: 2 }}>
        <SettingsLocation />
        <Divider component="li" />
        <ListItem>
          <ListItemText
            primary="Version"
            secondary={buildInfo.version}
          />
        </ListItem>
        <ListItem>
  
    <button
      onClick={() => {
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  
        </ListItem>
      </List>
    </Box>
  );
}
